



























































































































































































import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import {
  Meter,
  ResCode,
  PowerConditionerTableData,
  RsNetworkMeter,
  RsNetwork,
  RsNetworkMeterCheck,
  SimplifyMeter,
} from "@/api/baseDefine";

import { formatDate, formatDateTime } from "../../utils/dateUtil";
import {
  GetRsNetworksReq,
  rsNetworks,
  UpdateRsNetworkMeterReq,
  updateRsNetworkMeter,
} from "@/api/rsNetwork";
import { sendData, SendDataReq } from "../../api/meter";
@Component
export default class RsNetworkAdvanceDialog extends Vue {
  private mapIdNetworkMeter: Map<number, RsNetworkMeter> = new Map();
  private mapIndexNetworkMeter: Map<number, RsNetworkMeter> = new Map();
  private selectAll: boolean = false;
  private selectStartIndex = null;
  private selectEndIndex = null;
  private selectIndexArray: number[] = [];
  private baudRate: number = 0;
  private selectBaudRates: number[] = [
    2400,
    4800,
    9600,
    19200,
    38400,
    115200,
    153600,
  ];
  private sendArray: string[] = [
    "0020",
    "0021",
    "0022",
    "0023",
    "000E",
    "000F",
    "0010",
  ];
  private checkedSendArray: string[] = [];
  private rsNetworkMeters: RsNetworkMeter[] = [];
  private checkArray: boolean[] = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  private tableData2: RsNetworkMeterCheck[] = [
    {
      checkArray: this.checkArray,
    },
  ];
  private rsNetworkControlDialog: boolean = false;
  private clickShow(rsNetworkMeter: RsNetworkMeter) {
    console.log("rsNetworkControlDialog click show", rsNetworkMeter);
    this.rsNetworkControlDialog = true;
    this.loadAll(rsNetworkMeter);
  }

  private async onSettingChange(
    checked: boolean,
    rsNetworkMeterID: number,
    index: number
  ) {
    console.log("onSettingChange", checked, rsNetworkMeterID, index);
    let rsNetworkMeter: RsNetworkMeter | undefined = this.mapIdNetworkMeter.get(
      rsNetworkMeterID
    );
    if (!rsNetworkMeter) {
      return;
    }
    let s = checked ? "1" : "0";
    let length = rsNetworkMeter.setting.length;
    if (length < 7) {
      rsNetworkMeter.setting = "0000000";
    }
    length = 7;
    rsNetworkMeter.setting =
      rsNetworkMeter.setting.substr(0, index) +
      s +
      rsNetworkMeter.setting.substr(index + 1, length - 1 - index);
    let req: UpdateRsNetworkMeterReq = <UpdateRsNetworkMeterReq>{
      rsNetworkMeter: <RsNetworkMeter>{
        id: rsNetworkMeter.id,
        setting: rsNetworkMeter.setting,
      },
    };
    let res = await updateRsNetworkMeter(req);
    if (res.code === ResCode.SUCCESS) {
      this.mapIdNetworkMeter.set(rsNetworkMeterID, rsNetworkMeter);
    }
  }

  private onSelectAllChange(checked: boolean) {
    if (checked) {
      let checks: boolean[] = this.tableData2[0].checkArray;
      for (let i = 0; i < checks.length; i++) {
        // checks[i] = true;
        Vue.set(checks, i, true);
      }
    }
  }
  private async onSettingChange2(checked: boolean, index: number) {
    console.log("onSettingChange2", checked, index, this.tableData2[0]);
    let checks: boolean[] = this.tableData2[0].checkArray;
    for (let i = 0; i < checks.length; i++) {
      // checks[i] = true;
      if (!checks[i]) {
        this.selectAll = false;
        return;
      }
    }
    this.selectAll = true;
  }

  private reset() {
    let checks: boolean[] = this.tableData2[0].checkArray;
    for (let i = 0; i < checks.length; i++) {
      // checks[i] = true;
      Vue.set(checks, i, false);
    }
  }

  private async send() {
    let checks: boolean[] = this.tableData2[0].checkArray;
    this.checkedSendArray = [];
    for (let i = 0; i < checks.length; i++) {
      if (checks[i]) {
        this.checkedSendArray.push(this.sendArray[i]);
      }
    }
    if (
      !this.selectStartIndex ||
      !this.selectEndIndex ||
      Number(this.selectStartIndex) > Number(this.selectEndIndex) ||
      this.checkedSendArray.length <= 0
    ) {
      this.$message({
        message: this.$t("notification.inputIllegal").toString(),
        type: "warning",
      });
      return;
    }
    for (
      let i = Number(this.selectStartIndex);
      i <= Number(this.selectEndIndex);
      i++
    ) {
      for (let j = 0; j < this.checkedSendArray.length; j++) {
        let rsNetworkMeter:
          | RsNetworkMeter
          | undefined = this.mapIndexNetworkMeter.get(0);
        if (!rsNetworkMeter) {
          continue;
        }
        let subNetworkMeter:
          | RsNetworkMeter
          | undefined = this.mapIndexNetworkMeter.get(i);
        if (!subNetworkMeter) {
          continue;
        }
        console.log("senddata----------", i, j);
        let req: SendDataReq = <SendDataReq>{};
        req.meterIDs = [];
        req.meterIDs.push(<SimplifyMeter>{
          meterID: rsNetworkMeter.meter.meterID,
          meterTypeID: rsNetworkMeter.meter.meterTypeID,
        });
        req.dataType = 8;
        let index = 10 + i;

        let baudIndex =
          this.selectBaudRates.indexOf(rsNetworkMeter.baudRate) + 1;
        if (baudIndex <= 0) {
          baudIndex = 4;
        }
        req.params =
          index +
          "04" +
          "," +
          this.checkedSendArray[j] +
          "," +
          "01" +
          "," +
          "04" +
          "," +
          "10" +
          "," +
          subNetworkMeter.meter.meterID; // type 10是rs network
        let res = await sendData(req);
      }
    }
  }
  public async loadAll(rsNetworkMeter: RsNetworkMeter) {
    this.rsNetworkMeters = [];
    this.selectIndexArray = [];
    let req = <GetRsNetworksReq>{
      page: 1,
      pageSize: 100,
      masterType: 0,
      rsNetwork: <RsNetwork>{
        id: rsNetworkMeter.rsNetworkId,
      },
    };
    let res = await rsNetworks(req);
    for (let item of res.data.data.rsNetworks) {
      if (!!item.rsNetworkMeters && item.rsNetworkMeters.length > 0) {
        for (let rsNetworkMeter of item.rsNetworkMeters) {
          if (!!rsNetworkMeter.meter && !!rsNetworkMeter.meter.meterID) {
            this.mapIndexNetworkMeter.set(rsNetworkMeter.index, rsNetworkMeter);
            if (rsNetworkMeter.index == 0) {
              continue;
            }
            rsNetworkMeter.rsNetworkName = item.name;
            rsNetworkMeter.rsNetworkId = item.id;
            rsNetworkMeter.baudRate = item.baudRate;
            if (!!rsNetworkMeter.setting) {
              for (let i = 0; i < rsNetworkMeter.setting.length; i++) {
                rsNetworkMeter["check" + i] =
                  Number(rsNetworkMeter.setting[i]) > 0;
              }
            }
            this.selectIndexArray.push(rsNetworkMeter.index);
            this.mapIdNetworkMeter.set(rsNetworkMeter.id, rsNetworkMeter);
            this.rsNetworkMeters.push(rsNetworkMeter);
          }
        }
      }
    }
    console.log("loadAll", this.rsNetworkMeters);
  }
}
